@if (comment && (platform$ | async); as platform) {
  <div class="comment" [attr.data-comment-id]="comment.id">
    <div class="comment__image">
      <app-image [img]="comment.author.avatar?.previewNormal | addBaseUrl"></app-image>
    </div>
    <div class="comment__content">
      <a
        class="comment__name nav-link"
        [class.comment__name_active]="isActive"
        (click)="onAuthorClick()"
        [routerLink]="authorUrl"
      >
        @if (comment.author.dateEmployment | yearsOfServiceBadgeIcon; as badgeIcon) {
          <app-svg [icon]="badgeIcon" class="comment__years_of_service_badge"></app-svg>
        }
        <app-text
          [text]="comment.author | getFullName"
          [textSize]="TextSizes.h4Name"
          [textType]="TextType.base"
        ></app-text>
      </a>
      <div class="comment__text">
        <app-text [canCopy]="true" [textType]="TextType.base" [textSize]="TextSizes.h5Post">
          <div class="user-select-text" [innerHTML]="commentText | getInnerHtml"></div>
        </app-text>
      </div>
      @if (currentUser$ | async; as currentUser) {
        <div class="comment__controls">
          <app-text
            [text]="comment.created | dateFormat"
            [textSize]="TextSizes.date"
            [textType]="TextType.base"
          ></app-text>
          @if (
            currentUser.id !== comment.author.id &&
            (platform === Platform.desktop
              ? true
              : replyCommentId
                ? comment.id !== replyCommentId
                : true)
          ) {
            <button type="button" (click)="replyToComment()">
              <app-text
                [text]="comment.id === replyCommentId ? 'Отменить' : 'Ответить'"
                [textType]="TextType.base"
                [textSize]="TextSizes.numberPhone"
              ></app-text>
            </button>
          }
          @if (
            currentUser.id === comment.author.id &&
            (platform === Platform.desktop
              ? true
              : editCommentId
                ? comment.id !== editCommentId
                : true)
          ) {
            <button type="button" (click)="editComment()">
              <app-text
                [text]="comment.id === editCommentId ? 'Отменить' : 'Редактировать'"
                [textType]="TextType.base"
                [textSize]="TextSizes.numberPhone"
              ></app-text>
            </button>
          }
        </div>
      }
    </div>
  </div>
}

<div class="comment__replies" [class.comment__replies_nested]="replyLevel === 0">
  @for (comment of replyComments; track trackRepliesBy($index, comment)) {
    <app-post-comment
      [id]="comment.id"
      [comment]="comment"
      [replyLevel]="replyLevel + 1"
      [newComment]="newComment"
      [editCommentId]="editCommentId"
      [changeCommentEditMode]="changeCommentEditMode"
    ></app-post-comment>
  }
</div>
